<template>
  <Modal
    title="分享直播专题"
    :value="value"
    @input="$emit('input', $event)"
    @on-ok="openShortUrl(url)"
    ok-text="打开"
    width="580px"
  >
    <div class="categoryShareModal__copy">
      <div class="categoryShareModal__copy__item">
        <Input v-model="url" readonly class="copy__input" />
        <Button
          class="copy__button"
          type="primary"
          ref="playerUrl"
          :data-clipboard-text="url"
        >
          {{ $t("Button.copy.shortUrl") }}
        </Button>
      </div>
    </div>
    <div class="categoryShareModal__qrcode">
      <canvas ref="qrcode"></canvas>
    </div>
  </Modal>
</template>
<script>
import Clipboard from "clipboard";
import QRCode from "qrcode";

export default {
  props: {
    url: {
      type: String,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clipboards: [],
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.useQrcode();
      }
    },
  },
  methods: {
    useQrcode() {
      let canvas = this.$refs.qrcode;
      QRCode.toCanvas(
        canvas,
        this.url,
        {
          width: 148,
          height: 148,
        },
        function (error) {
          if (error) console.error(error);
          console.log("QRCode success!");
        }
      );
    },
    openShortUrl(url) {
      window.open(url, "_blank");
    },
    //复制
    initCopy() {
      this.clipboards = [this.$refs.playerUrl.$el].map((btn) => {
        let clipboard = new Clipboard(btn);
        clipboard.on("success", () => {
          this.$Message.success(this.$t("Message.copy.success"));
        });
        clipboard.on("error", () => {
          // 不支持复制
          this.$Message.error(this.$t("Message.copy.nonsupport"));
        });
        return clipboard;
      });
    },
  },
  mounted() {
    this.initCopy();
  },
  beforeDestroy() {
    this.clipboards.forEach((c) => c.destroy());
  },
};
</script>

<style scoped lang="less">
.categoryShareModal__copy {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .categoryShareModal__copy__item {
    display: flex;
    gap: 15px;
  }
}

.categoryShareModal__qrcode {
  display: flex;
  margin-top: 15px;
  justify-content: center;

  canvas {
    width: 148px;
    height: 148px;
  }
}
</style>
